import { render } from "./RandomTiles.vue?vue&type=template&id=1c0d5b5c&scoped=true"
import script from "./RandomTiles.vue?vue&type=script&lang=js"
export * from "./RandomTiles.vue?vue&type=script&lang=js"

import "./RandomTiles.vue?vue&type=style&index=0&id=1c0d5b5c&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0d5b5c"]])

export default __exports__